import OfferHeader from "./Components/Offer/OfferHeader.vue";
import OfferExpandableSection from "./Components/Offer/OfferExpandableSection.vue";
import OfferLocation from "./Components/Offer/OfferLocation.vue";
import OfferTile from "./Components/Offer/OfferTile.vue";
import { MyMarketplaceRouteGuard } from "./MyMarketplaceRouteGuard";

export
{
    OfferHeader,
    OfferExpandableSection,
    OfferLocation,
    OfferTile
};

export default [
    {
        path: '/my-marketplace',
        name: 'Marketplace',
        meta: {
            allowAnonymous: false,
            title: 'Marketplace'
        },
        beforeEnter: MyMarketplaceRouteGuard,
        component: () => import( './Views/Marketplace.vue' )
    },
    {
        path: '/my-marketplace/offer/:offerId/:conditionType?',
        name: 'Offer',
        meta: {
            allowAnonymous: false, 
            title: 'Offer'
        },
        component: () => import( './Views/Offer.vue' )
    }
];